import { Helmet } from "react-helmet";
import Logo from "../assets/logo.png";

interface Props {
  title: string;
  image?: string;
  description: string;
}

export const MetaTag = ({ title, image, description }: Props) => {
  return (
    <Helmet>
      <title>{`${title}`}</title>
      <meta name="description" content={`${description}`} />
      <meta property="og:title" content={`${title}`} />
      <meta property="og:description" content={`${description}`} />
      <meta property="og:url" content={window.location.href} />
      <meta
        property="og:image"
        itemProp="image"
        content={
          image ? image : `${process.env.REACT_APP_FRONTEND_URL}/logo.png`
        }
      />
      <meta property="og:type" content="website" />
      <meta property="twitter:title" content={`${title}`} />
      <meta property="twitter:description" content={`${description}`} />
      <meta
        property="twitter:image"
        itemProp="image"
        content={
          image ? image : `${process.env.REACT_APP_FRONTEND_URL}/logo.png`
        }
      />
      <meta property="twitter:card" content="summary_large_image" />

      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};
